import React from 'react'
import { Stack, Divider } from "@mui/material";

import { formatDate } from "../../utils";

const RiskFactorShow = ( {riskFactorData} ) => {
  return (
    <Stack
      spacing={4}
      divider={
        <Divider
          sx={{
            borderColor: "#b0bec5",
            borderBottomWidth: 2,
            marginY: 2,
          }}
          orientation="horizontal"
        />
      }
    >
      <Stack spacing={2}>
        <h3>Risk Factor Data</h3>
        <p>
          <strong>Patient ID:</strong> {riskFactorData.patient_id}
        </p>
        <p>
          <strong>Creation Date:</strong>{" "}
          {formatDate(riskFactorData.creation_date)}
        </p>
      </Stack>
      {Object.keys(riskFactorData)
        .filter((key) => !["id", "patient_id", "creation_date"].includes(key)) // Exclude metadata keys
        .map((sectionKey) => {
          const sectionData = JSON.parse(riskFactorData[sectionKey]); // Parse JSON string for each section
          return (
            <Stack key={sectionKey} spacing={2}>
              <h3>{sectionData.header}</h3>
              {Object.keys(sectionData)
                .filter((questionKey) => questionKey.startsWith("q")) // Filter for questions (q1, q2, etc.)
                .map((questionKey, index) => (
                  <div key={questionKey} style={{ marginBottom: "10px" }}>
                    <p>
                      <strong>
                        {index + 1}. {sectionData[questionKey]}
                      </strong>
                    </p>
                    <p>
                      <em>Answer:</em>{" "}
                      {sectionData[`a${index + 1}`] || "Not answered"}
                    </p>
                  </div>
                ))}
            </Stack>
          );
        })}
    </Stack>
  );
}

export default RiskFactorShow